import axios from "axios";
import { msalInstance } from "../../index";
import { setGlobalLoader, showSnackbar } from "../../redux/actions/commonAction";
import store from '../../redux/store/reduxStore';
import storage from '../../utils/storage';
import { loginRequest } from '../azure/authConfig';

const refreshToken = async () => {
    let response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: msalInstance.getActiveAccount(),
    })
    const { idToken, tokenType } = response
    const token = `${tokenType} ${idToken}`;
    storage.setItem("auth", response);
    storage.setItem("token", token);
    return token
}

export const axiosInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.request.use(
        async (config) => {
            if (config.data instanceof FormData) {
                config.headers["Content-Type"] = "multipart/form-data"
            }
            else {
                config.headers["Content-Type"] = "application/json"
            }
            const token = await storage.getItem("token")
            if (token) {
                config.headers["Authorization"] = token
                config.headers["Authtype"] = "MSAL";
            }
            return config;
        },
        (error) => Promise.reject(error.response.data)
    );
    axiosInstance.interceptors.response.use(
        (response) => {
            return response?.data;
        },
        async error => {
            console.log('axios error------->>>', error)
            store.dispatch(setGlobalLoader(false));
            const errorMessage = error.response?.data?.errorMsg ||
                error.response?.data?.error ||
                error.response?.data?.message?.description ||
                error.response?.data?.message
            const originalRequest = error.config;
            originalRequest._retry = true;
            if (errorMessage === "Invalid authorization token: ExpiredSignatureError" ||
                error.response.status === 401 ||
                !originalRequest._retry) {
                const accessToken = await refreshToken();
                if (accessToken) {
                    axios.defaults.headers.common["Content-Type"] = "application/json"
                    axios.defaults.headers.common['Authorization'] = accessToken
                    axios.defaults.headers.common["Authtype"] = "MSAL";
                    return axiosInstance(originalRequest);
                }
            }
            else if (error?.response && errorMessage) {
                store.dispatch(
                    showSnackbar({
                        message: errorMessage,
                        severity: "error",
                        open: true,
                    })
                );
            }
            return Promise.reject(error);
        }
    );
};
